//// Application Configuration
import local_configuration from '../../configurations/iat-ui-config.json'

//// Application Packages
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

//// Application Modules

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    createAuthorizations,
    deleteAuthorizations,
    selectAuthorizations,
} from '../../reducers/authorizationSlice'
import {
    createAccountAuxiliary,
    deleteAccountData,
    deleteAccountValidity,
    deleteAccountAuxiliary,
} from '../../reducers/accountSlice'
import {
    createFormAuxiliary,
    updateFormAuxiliary,
    createSubFormValidity,
    deleteFormData,
    deleteFormValidity,
    deleteFormAuxiliary,
    updateSubFormAuxiliary,
    deleteSubFormData,
    deleteSubFormValidity,
    deleteSubFormAuxiliary,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import {
    Header,
    HeaderName,
    HeaderGlobalBar,
    HeaderNavigation,
    HeaderMenuItem,
    Theme,
} from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////////////// Component
const PageNavigationComponent = () => {
    //////// Hooks
    const dispatch = useDispatch()
    const navigate = useNavigate()

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const auth = useSelector(selectAuthorizations)

    //// Slice Data
    const project_name = settingsData?.['application']?.['project_name']
    const application_name = settingsData?.['application']?.['application_name']
    const cookie = auth?.['tokens']?.['cookie']
    const form = auth?.['tokens']?.['form']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Handle Logout
    const handleLogout = () => {
        //// Perform Browser Effects

        localStorage.clear()
        sessionStorage.clear()

        //// End Perform Browser Effects

        // Clear Authorizations
        dispatch(deleteAuthorizations())

        //// Paginated Data
        if (local_configuration) {
            const config = Object?.keys(local_configuration)
            if (config?.length > 0) {
                //// Clear Account Data, Errors & Settings
                const account_config = local_configuration?.['pages']
                if (account_config) {
                    const titles = Object?.keys(account_config)
                    if (titles?.length > 0) {
                        titles?.forEach((el) => {
                            dispatch(
                                deleteAccountData({
                                    digital_name: el,
                                })
                            )
                            dispatch(
                                deleteAccountValidity({
                                    digital_name: el,
                                })
                            )
                            dispatch(
                                deleteAccountAuxiliary({
                                    digital_name: el,
                                })
                            )
                        })
                    }
                }

                //// Clear Form Data, Errors & Settings
                const forms_config = local_configuration?.['forms']
                if (forms_config) {
                    const categories = Object?.keys(forms_config)
                    if (categories?.length > 0) {
                        categories.forEach((el) => {
                            const forms = forms_config[el]
                            if (forms) {
                                const titles = Object?.keys(forms)
                                if (titles?.length > 0) {
                                    titles.forEach((el) => {
                                        const title = el
                                        const form = forms?.[el]
                                        if (
                                            form?.['view_structure'] === 'form'
                                        ) {
                                            dispatch(
                                                deleteFormData({
                                                    digital_name: title,
                                                })
                                            )
                                            dispatch(
                                                deleteFormValidity({
                                                    digital_name: title,
                                                })
                                            )
                                            dispatch(
                                                deleteFormAuxiliary({
                                                    digital_name: title,
                                                })
                                            )
                                            if (form?.['auxiliary']) {
                                                dispatch(
                                                    updateFormAuxiliary({
                                                        digital_name: title,
                                                        auxiliary:
                                                            form?.auxiliary,
                                                    })
                                                )
                                            }
                                        } else if (
                                            form?.['view_structure'] ===
                                            'sub-forms'
                                        ) {
                                            const subForms = form?.['sub_forms']
                                            if (subForms?.length > 0) {
                                                subForms.forEach((el) => {
                                                    const subFormTitle = el
                                                    dispatch(
                                                        deleteSubFormData({
                                                            digital_name: title,
                                                            digital_sub_name:
                                                                subFormTitle,
                                                        })
                                                    )
                                                    dispatch(
                                                        deleteSubFormValidity({
                                                            digital_name: title,
                                                            digital_sub_name:
                                                                subFormTitle,
                                                        })
                                                    )
                                                    dispatch(
                                                        deleteSubFormAuxiliary({
                                                            digital_name: title,
                                                            digital_sub_name:
                                                                subFormTitle,
                                                        })
                                                    )
                                                    if (form?.['auxiliary']) {
                                                        dispatch(
                                                            updateSubFormAuxiliary(
                                                                {
                                                                    digital_name:
                                                                        title,
                                                                    digital_sub_name:
                                                                        subFormTitle,
                                                                    auxiliary:
                                                                        form?.auxiliary,
                                                                }
                                                            )
                                                        )
                                                    }
                                                })
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            }
        }

        //// End Clear Existing Data

        // Restore Deep Link
        dispatch(createAuthorizations({ form: form }))

        //// Perform Browser Effects

        console.clear()
        window.location.reload()

        //// End Perform Browser Effects

        // Dispatch Configuration Data To Page & Form Data
        if (local_configuration) {
            // Restore Pages Defaults
            const pages = local_configuration?.['pages']
            if (pages) {
                const pageTitles = Object?.keys(pages)
                if (pageTitles?.length > 0) {
                    pageTitles.forEach((el) => {
                        const title = el
                        const page = page?.[el]
                        if (page?.['auxiliary']) {
                            const auxiliary = page?.auxiliary
                            dispatch(
                                createAccountAuxiliary({
                                    digital_name: title,
                                    auxiliary: auxiliary,
                                })
                            )
                        }
                    })
                }
            }

            // Restore Forms Defaults
            const forms = local_configuration?.['forms']
            if (forms) {
                const formTitles = Object?.keys(forms)
                if (formTitles?.length > 0) {
                    formTitles.forEach((el) => {
                        const title = el
                        const form = forms?.[el]
                        if (form?.['auxiliary']) {
                            const auxiliary = form?.auxiliary
                            dispatch(
                                createFormAuxiliary({
                                    digital_name: title,
                                    auxiliary: auxiliary,
                                })
                            )
                        }
                        if (!form?.['values'] && !form?.['auxiliary']) {
                            const subFormTitles = Object?.keys(form)
                            if (subFormTitles?.length > 0) {
                                subFormTitles.forEach((el) => {
                                    const subTitle = el
                                    const subForm = form?.[el]
                                    if (subForm?.['auxiliary']) {
                                        const subFormAuxiliary =
                                            subForm?.auxiliary
                                        dispatch(
                                            createSubFormValidity({
                                                digital_name: title,
                                                digital_sub_name: subTitle,
                                                auxiliary: subFormAuxiliary,
                                            })
                                        )
                                    }
                                })
                            }
                        }
                    })
                }
            }
        }
    }

    // Handle Navigation
    const handleNavigation = (e, link) => {
        e.preventDefault()
        navigate(link ? link : '/')
    }

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div className="fldoh-page-nav container">
                <Theme theme="white">
                    <Header aria-label={project_name + ' ' + application_name}>
                        <HeaderName
                            href={''}
                            prefix={project_name}
                            onClick={(e) => handleNavigation(e, '/')}
                        >
                            {application_name}
                        </HeaderName>
                        <HeaderGlobalBar>
                            <HeaderNavigation
                                aria-label={
                                    project_name +
                                    ' ' +
                                    '[' +
                                    application_name +
                                    ']'
                                }
                            >
                                {cookie ? (
                                    <HeaderMenuItem
                                        href={''}
                                        onClick={handleLogout}
                                        target="_self"
                                        rel="noreferrer noopener"
                                        aria-label="logout-link"
                                        type="link"
                                    >
                                        Logout
                                    </HeaderMenuItem>
                                ) : (
                                    <HeaderMenuItem
                                        href={''}
                                        onClick={(e) =>
                                            handleNavigation(
                                                e,
                                                '/account/login'
                                            )
                                        }
                                        target="_self"
                                        rel="noreferrer noopener"
                                        aria-label="login-link"
                                        type="link"
                                    >
                                        Login
                                    </HeaderMenuItem>
                                )}

                                <HeaderMenuItem
                                    href={
                                        'https://wa-oit-contactus-prd.azurewebsites.net/'
                                    }
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    aria-label="contact-us-link"
                                    type="link"
                                >
                                    Contact Us
                                </HeaderMenuItem>
                            </HeaderNavigation>
                        </HeaderGlobalBar>
                    </Header>
                </Theme>
            </div>
        </>
    )
}

export default PageNavigationComponent
